import { useAuth0 } from "@auth0/auth0-react";
import { AuthContext } from "./AuthContext";

/**
 * Today's default auth path (AUTH_MODE unset or "auth0-spa"). Mounted INSIDE <Auth0Provider>
 * (see App.js) so useAuth0() has a provider to read from. Calls exactly one hook (useAuth0),
 * unconditionally -- see AuthContext.js for why the mode branch lives in App.js instead of here.
 *
 * Passes useAuth0()'s fields straight through: every consumer (AppContent, SecureRoute, Login,
 * Logout, useAuth0ApiReady, AppShell, ExplorerAppHeader) was written against this exact shape,
 * so this bridge is deliberately a no-op translation layer, not a new behavior.
 */
export function Auth0AuthBridge({ children }) {
  const {
    isAuthenticated,
    isLoading,
    user,
    error,
    logout,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0();

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        user,
        error,
        logout,
        loginWithRedirect,
        getAccessTokenSilently,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
